import { render, staticRenderFns } from "./DeleteAllSharingLinks.vue?vue&type=template&id=01287a61&"
import script from "./DeleteAllSharingLinks.vue?vue&type=script&lang=js&"
export * from "./DeleteAllSharingLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports